
import Axios from 'axios'
import store from '../store'
export default {
    submitBet(betCriteria) {
        var criteria = {
            punterId: betCriteria.punterId ? betCriteria.punterId : store.getters.punterId,
            totalOdds: betCriteria.totalOdds,
            totalStake: betCriteria.totalStake,
            totalPayout: betCriteria.totalPayout,
            priceChangeDrift: betCriteria.priceChangeDrift,
            betLegs:[]
        }

        let betlegsLength = betCriteria.betLegs.length;
        for (let i = 0; i < betlegsLength; i++) {
            criteria.betLegs.push(betCriteria.betLegs[i].betleg);
        }
        Axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.accessToken;
        return Axios.post(`/api/liveinplay/submit`, criteria)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            })
    }
}